export default __webpack_public_path__ + "static/media/bursaries_m@2x.98834dd2.png";